import { Box, IconButton, Tooltip } from '@mui/material';
import { MessageSquare } from 'lucide-react';
import { useRecoilState } from 'recoil';
import FeatureToggle, { Features } from '~/components/FeatureToggle';
import { chatDrawerOpenState } from '~/state/atoms/chatAtoms';
import About from './About';
import ExternalLinksMenu from './ExternalLinksMenu';
import GlobalSettings from './GlobalSettings';

function ChatToggleButton() {
    const [open, setOpen] = useRecoilState(chatDrawerOpenState);

    return (
        <Tooltip title={open ? 'Close AI Assistant' : 'Open AI Assistant'}>
            <IconButton
                size="small"
                onClick={() => setOpen((prev) => !prev)}
                color={open ? 'primary' : 'default'}
            >
                <MessageSquare size={20} />
            </IconButton>
        </Tooltip>
    );
}

export default function ApplicationQuickMenu() {
    return (
        <Box display="flex" gap={0.5} flexDirection="row" alignItems="center">
            <FeatureToggle feature={Features.AI_CHAT}>
                <ChatToggleButton />
            </FeatureToggle>
            <About />
            <GlobalSettings />
            <ExternalLinksMenu />
        </Box>
    );
}
